import { Box, Button, Flex, Input, Spinner, Text } from '@chakra-ui/react';
import { ReactComponent as UploadIcon } from 'assets/icons/upload_cloud.svg';
import { ALLOW_IMAGE_TYPES } from 'constants/imageUpload';
import { useAppSelector } from 'modules/Editor/store';
import { selectIsUploading } from 'modules/Editor/store/editorSettingsSelector';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

interface UploadButtonProps {
  inputRef: React.RefObject<HTMLInputElement>;
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleUploadBtnClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const UploadButton = ({ inputRef, handleFileChange, handleUploadBtnClick }: UploadButtonProps): ReactElement => {
  const ACCEPTED_IMAGE_TYPES_STR = ALLOW_IMAGE_TYPES.join(',');
  const isUploading = useAppSelector(selectIsUploading);
  const { t } = useTranslation('editor_widget_menu', { useSuspense: false, keyPrefix: 'sideMenu.imagesMenu' });

  return (
    <>
      <Input
        id='image-upload'
        type='file'
        ref={inputRef}
        display='none'
        onChange={handleFileChange}
        accept={ACCEPTED_IMAGE_TYPES_STR}
        aria-label={t('uploadInputAriaLabel')}
        multiple
      />
      <Button
        size='sm'
        variant='action'
        onClick={handleUploadBtnClick}
        isDisabled={isUploading}
        leftIcon={!isUploading ? <UploadIcon width='20px' color='white' /> : undefined}
        data-testid='upload-button'
        minH='32px'
      >
        {isUploading ? (
          <Flex flexDir='row' justifyContent='center' alignItems='center'>
            <Spinner speed='0.65s' size='sm' />
            <Text ml='2'>{t('uploading')}</Text>
          </Flex>
        ) : (
          <Box as='span'>{t('folders.upload')}</Box>
        )}
      </Button>
    </>
  );
};
